import React from "react";
import com_logo_1 from "../../assets/images/homePage/community_chat.svg";
import com_logo_2 from "../../assets/images/homePage/community_check.svg";
import com_logo_3 from "../../assets/images/homePage/community_discord.svg";
import com_logo_4 from "../../assets/images/homePage/community_telegram.svg";
import useTranslation from "../../Languages/Translation";

const Community = () => {

  const translation = useTranslation();

  return (
    <div className="border-t-[#22262B] border-t-[1px] border-b-[#22262B] border-b-[1px]">
      <div className=" main_container py-[30px] md:py-[80px]">
        <div className="">
          <p className="text-[32px] text-white aeonik_medium leading-[40px]">
            {translation.JointheCommunity}
          </p>
          <p className="text-[18px] text-white aeonik_normal leading-[22px] mt-[12px] max-w-[577px]">
            {translation.joindesc}
          </p>
        </div>
        <div className="grid grid-cols-12 gap-x-[15px] lg:gap-x-[32px] mt-[48px]">
          <div className={`col-span-6 lg:col-span-3 mb-[15px] lg:mb-0  cursor-pointer flex flex-col bg-[#1c1f23] p-[20px] lg:p-[32px] rounded-[24px]`} >
            <img
              src={com_logo_1}
              alt="logo"
              className="h-[44px] w-auto object-contain mr-auto"
            />
            <p className={`text-[24px] text-[#010304] aeonik_medium mt-[12px]`}>
              {translation.Forum}
            </p>
          </div>
          <div className={`col-span-6 lg:col-span-3 mb-[15px] lg:mb-0 cursor-pointer flex flex-col bg-[#1c1f23] p-[20px] lg:p-[32px] rounded-[24px]`} >
            <img
              src={com_logo_2}
              alt="logo"
              className="h-[44px] w-auto object-contain mr-auto"
            />
            <p className={`text-[24px] text-[#fff] aeonik_medium mt-[12px]`}>
              {translation.Vote}
            </p>
          </div>
          <div
            className={`col-span-6 lg:col-span-3 cursor-pointer flex flex-col bg-[#5A65EA] p-[20px] lg:p-[32px] rounded-[24px]`}
          >
            <img
              src={com_logo_3}
              alt="logo"
              className="h-[44px] w-auto object-contain mr-auto"
            />
            <p className={`text-[24px] text-[#fff] aeonik_medium mt-[12px]`}>
              {translation.Discord}
            </p>
          </div>
          <div
            className={`col-span-6 lg:col-span-3 cursor-pointer flex flex-col bg-[#3B86C6] p-[20px] lg:p-[32px] rounded-[24px]`}
          >
            <img
              src={com_logo_4}
              alt="logo"
              className="h-[44px] w-auto object-contain mr-auto"
            />
            <p className={`text-[24px] text-[#fff] aeonik_medium mt-[12px]`}>
              {translation.Telegram}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Community;
